import React, { useState, useEffect } from 'react';

export default function ErrorLog() {
  const [errors, setErrors] = useState([]);
  const [expanded, setExpanded] = useState(false);

  // Load errors from sessionStorage
  useEffect(() => {
    // Check for errors initially
    const loadErrors = () => {
      const storedErrors = JSON.parse(sessionStorage.getItem('asana_errors') || '[]');
      setErrors(storedErrors);
    };

    loadErrors();

    // Set up an interval to check periodically for new errors
    const interval = setInterval(loadErrors, 5000);

    return () => clearInterval(interval);
  }, []);

  // If no errors, don't render anything
  if (errors.length === 0) {
    return null;
  }

  return (
    <div className="fixed bottom-8 right-2 z-50 w-96 shadow-lg rounded-lg overflow-hidden">
      <div
        className="bg-red-600 text-white px-4 py-2 flex justify-between items-center cursor-pointer"
        onClick={() => setExpanded(!expanded)}
      >
        <span className="font-semibold">
          {errors.length} Error{errors.length !== 1 ? 's' : ''}
        </span>
        <span className="text-xl">{expanded ? '▼' : '▲'}</span>
      </div>

      {expanded && (
        <div className="bg-white border border-red-300 max-h-96 overflow-y-auto">
          {errors.map((error, index) => (
            <div key={index} className="p-3 border-b border-red-200">
              <div className="text-sm text-gray-500 mb-1">
                {error.timestamp ? new Date(error.timestamp).toLocaleString() : 'Unknown time'}
              </div>

              {error.endpoint && (
                <div className="text-xs text-gray-600 mb-1">
                  Endpoint: {error.endpoint}
                </div>
              )}

              {error.status && (
                <div className="text-sm font-semibold mb-1">
                  Status: {error.status}
                </div>
              )}

              {error.error && (
                <div className="text-sm text-red-600">
                  Error: {error.error}
                </div>
              )}

              {error.response && (
                <div className="mt-2">
                  <div className="text-xs text-gray-600 mb-1">Response:</div>
                  <pre className="text-xs bg-gray-100 p-2 rounded overflow-x-auto">
                    {JSON.stringify(error.response, null, 2)}
                  </pre>
                </div>
              )}
            </div>
          ))}

          <div className="p-2 bg-gray-100 flex justify-end">
            <button
              className="px-3 py-1 bg-gray-300 text-gray-700 rounded text-sm hover:bg-gray-400"
              onClick={() => {
                sessionStorage.removeItem('asana_errors');
                setErrors([]);
              }}
            >
              Clear Errors
            </button>
          </div>
        </div>
      )}
    </div>
  );
}
